// Printer Image Component - Optimized sizes and better contrast

interface PrinterImageProps {
    model: string;
    size?: 'small' | 'medium' | 'large';
    className?: string;
}

export default function PrinterImage({ model, size = 'medium', className = '' }: PrinterImageProps) {
    // Map model names to image files
    const getImagePath = (modelName: string): string => {
        const normalized = modelName.toUpperCase().trim();

        if (normalized.includes('MC110')) return 'images/MC110.png';
        if (normalized.includes('MC210')) return 'images/MC210.png';
        if (normalized.includes('MC310')) return 'images/MC310.png';
        if (normalized.includes('XID8300') || normalized.includes('XID 8300')) return 'images/XID8300.png';
        if (normalized.includes('XID8600') || normalized.includes('XID 8600')) return 'images/XID8600.png';
        if (normalized.includes('XL8300') || normalized.includes('XL 8300')) return 'images/XL8300.png';

        // Default to MC210 if model not recognized
        return 'images/MC210.png';
    };

    const sizeStyles = {
        small: { maxWidth: '60px', maxHeight: '60px' },
        medium: { maxWidth: '100px', maxHeight: '100px' },
        large: { maxWidth: '120px', maxHeight: '120px' }
    };

    return (
        <img
            src={getImagePath(model)}
            alt={`${model} Printer`}
            className={className}
            style={{
                ...sizeStyles[size],
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
                filter: 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.4)) brightness(1.15) contrast(1.1)'
            }}
        />
    );
}
